/*
  Purekey: predal in stran košarice.

  1. Potrditev pogojev v predalu (vsi jeziki). Nakup gre iz predala naravnost v blagajno kot na stari temi,
     zato je gumb #CartDrawer-Checkout onemogočen, dokler kljukica #CartDrawer-PrivacyPolicy ni potrjena,
     enako kot na strani košarice. Flow predal ob vsaki spremembi košarice izriše na novo (innerHTML),
     zato se potrditev hrani tu in se nastavi na vsaki novi kljukici in gumbu.

  2. Ime popusta v jeziku strani (samo v drugem jeziku: theme.liquid skripti doda data-pk-translate-discounts).
     Ime paketa Mix & Save prevede Adoric: v podatkih košarice je prevedeno (/sl/cart.js: »Paket 3+ izdelkov«),
     Shopify pa v izrisu sekcij vrne izvirno ime (»3+ products«). Stara tema je predal gradila iz podatkov
     košarice, Flow ga izriše kot sekcijo, zato skripta ime z oznako data-pk-discount (ključ vrstice) in
     data-pk-discount-index zamenja z imenom iz cart.js. Dokler ga ne dobi, je ime skrito (pk-base.css).
*/
(() => {
  const script = document.currentScript;
  const translateDiscounts = Boolean(script && script.hasAttribute('data-pk-translate-discounts'));

  /* ----- 1. Potrditev pogojev ----- */
  const TERMS = 'CartDrawer-PrivacyPolicy';
  const CHECKOUT = 'CartDrawer-Checkout';
  let accepted = false;

  const syncTerms = () => {
    const checkbox = document.getElementById(TERMS);
    const button = document.getElementById(CHECKOUT);
    if (checkbox && checkbox.checked !== accepted) checkbox.checked = accepted;
    if (button && button.disabled === accepted) {
      button.disabled = !accepted;
      button.setAttribute('aria-disabled', String(!accepted));
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.id !== TERMS) return;
    accepted = event.target.checked;
    syncTerms();
  });

  /* ----- 2. Ime popusta ----- */
  const url = `${(window.routes && window.routes.cart_url) || '/cart'}.js`;
  let running = false;
  let again = false;
  let timer = null;

  const run = async () => {
    if (running) {
      again = true;
      return;
    }
    running = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);

    try {
      const cart = await fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal }).then((response) => response.json());
      document.querySelectorAll('[data-pk-discount]').forEach((element) => {
        const line = cart.items.find((item) => item.key === element.dataset.pkDiscount);
        const allocation = line && line.line_level_discount_allocations[Number(element.dataset.pkDiscountIndex)];
        const title = allocation && allocation.discount_application && allocation.discount_application.title;
        if (title && element.textContent !== title) element.textContent = title;
      });
    } catch (error) {
      // Brez podatkov košarice ostane izvirno ime
    } finally {
      clearTimeout(timeout);
      running = false;
      if (again) {
        again = false;
        run();
      } else {
        document.querySelectorAll('[data-pk-discount][data-pk-pending]').forEach((element) => element.removeAttribute('data-pk-pending'));
      }
    }
  };

  // Nova imena (prvi izris, osvežen predal, stran košarice) skrije in jih pošlje po prevod
  const collect = () => {
    const fresh = document.querySelectorAll('[data-pk-discount]:not([data-pk-seen])');
    if (!fresh.length) return;
    fresh.forEach((element) => {
      element.setAttribute('data-pk-seen', '');
      element.setAttribute('data-pk-pending', '');
    });
    clearTimeout(timer);
    timer = setTimeout(run, 30);
  };

  /* ----- Ob vsakem izrisu predala ----- */
  const update = () => {
    syncTerms();
    if (translateDiscounts) collect();
  };

  update();
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

  // Adoric jezik košarice nastavi med nalaganjem strani (npr. po menjavi jezika), zato še en prehod na koncu
  if (translateDiscounts) {
    window.addEventListener('load', () => {
      if (document.querySelector('[data-pk-discount]')) run();
    });
  }
})();
